import React from 'react';
import { Users, BookCopy, Gift, Star } from 'lucide-react';
export function SocialProofBar() {
  return <div className="bg-brand-card text-white py-5 md:py-6 px-4 border-y border-brand-accent/30" data-id="element-257">
      <div className="max-w-4xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-258">
        <div className="flex flex-col items-center text-center" data-id="element-259">
          <Users className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-260" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-261">+300</span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-262">
            docentes confían
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-263">
          <BookCopy className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-264" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-265">
            6 Tomos
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-266">
            listos para usar
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-267">
          <Gift className="w-6 h-6 md:w-7 md:h-7 mb-1.5 text-brand-accent" data-id="element-268" />
          <span className="text-lg md:text-xl font-black text-white" data-id="element-269">
            4 Bonos
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-270">
            incluidos gratis
          </span>
        </div>

        <div className="flex flex-col items-center text-center" data-id="element-271">
          <div className="flex mb-1.5" data-id="element-272">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 md:w-6 md:h-6 text-brand-accent fill-current" data-id="element-273" />)}
          </div>
          <span className="text-lg md:text-xl font-black text-white" data-id="element-274">
            4.9/5
          </span>
          <span className="text-xs md:text-sm text-gray-400 font-medium" data-id="element-275">
            valoración
          </span>
        </div>
      </div>
    </div>;
}